import { useEffect, useRef, useState } from "react";
import Stage from "@/components/projection/Stage";
import { CHANNEL, DEFAULT_SETTINGS, protectHandlers } from "@/components/projection/projection";

const KEYMAP = { ArrowRight: "next", ArrowDown: "next", PageDown: "next", " ": "next", ArrowLeft: "prev", ArrowUp: "prev", PageUp: "prev", b: "blank", B: "blank", ".": "blank", Home: "first", End: "last" };

export default function ProjectionDisplay() {
  const [state, setState] = useState(null);
  const [idle, setIdle] = useState(false);
  const chan = useRef(null);

  useEffect(() => {
    document.title = "HOH Hymn Projection — Display";
    const c = new BroadcastChannel(CHANNEL);
    chan.current = c;
    c.onmessage = (e) => { if (e.data?.type === "state") setState(e.data.payload); if (e.data?.type === "closed") setState(null); };
    c.postMessage({ type: "hello" });
    const onKey = (e) => {
      if (e.key === "f" || e.key === "F") { toggleFs(); return; }
      const action = KEYMAP[e.key];
      if (action) { e.preventDefault(); c.postMessage({ type: "key", action }); }
    };
    window.addEventListener("keydown", onKey);
    const unprotect = protectHandlers();
    return () => { c.close(); window.removeEventListener("keydown", onKey); unprotect(); };
  }, []);

  useEffect(() => {
    let t;
    const move = () => { setIdle(false); clearTimeout(t); t = setTimeout(() => setIdle(true), 2500); };
    window.addEventListener("mousemove", move);
    move();
    return () => { window.removeEventListener("mousemove", move); clearTimeout(t); };
  }, []);

  const toggleFs = () => {
    const p = document.fullscreenElement ? document.exitFullscreen() : document.documentElement.requestFullscreen?.();
    p?.catch?.(() => {});
  };
  const settings = state?.settings || DEFAULT_SETTINGS;
  const bg = settings.theme === "light" ? "#F7F5EF" : "#000";

  return (
    <div data-testid="projection-display" onDoubleClick={toggleFs} className="fixed inset-0 flex items-center justify-center select-none"
      style={{ background: bg, cursor: idle ? "none" : "default" }}>
      <div style={{ width: "min(100vw, 177.78vh)" }}>
        {state ? (
          <Stage slide={state.slide} meta={state.meta} settings={settings} blank={state.blank} testId="display-stage" />
        ) : (
          <div className="aspect-video flex flex-col items-center justify-center text-center gap-4" data-testid="display-waiting">
            <img src="/hoh-vibes-logo-128.png" alt="HOH_Vibes" className="w-20 h-20 rounded-full opacity-80" />
            <div className="font-serif-display text-3xl text-white">HOH Hymn Projection</div>
            <div className="text-neutral-500 text-sm max-w-md">Waiting for the presenter console. Move this window to the projector or TV, then double-click (or press F) for full screen.</div>
          </div>
        )}
      </div>
      {!idle && (
        <button onClick={toggleFs} data-testid="display-fullscreen" className="fixed bottom-4 right-4 text-[10px] tracking-widest uppercase px-3 py-2 rounded border border-white/20 text-neutral-300 bg-black/60">
          Full screen (F)
        </button>
      )}
    </div>
  );
}
